import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-drag",
  "use": "icon-drag-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-drag\"><path d=\"M365.714286 438.857143a73.142857 73.142857 0 1 1 0-146.285714 73.142857 73.142857 0 0 1 0 146.285714z m0 292.571428a73.142857 73.142857 0 1 1 0-146.285714 73.142857 73.142857 0 0 1 0 146.285714z m0 292.571429a73.142857 73.142857 0 1 1 0-146.285714 73.142857 73.142857 0 0 1 0 146.285714zM658.285714 146.285714a73.142857 73.142857 0 1 1 0-146.285714 73.142857 73.142857 0 0 1 0 146.285714z m0 292.571429a73.142857 73.142857 0 1 1 0-146.285714 73.142857 73.142857 0 0 1 0 146.285714z m0 292.571428a73.142857 73.142857 0 1 1 0-146.285714 73.142857 73.142857 0 0 1 0 146.285714z m0 292.571429a73.142857 73.142857 0 1 1 0-146.285714 73.142857 73.142857 0 0 1 0 146.285714zM365.714286 146.285714a73.142857 73.142857 0 1 1 0-146.285714 73.142857 73.142857 0 0 1 0 146.285714z\" p-id=\"11372\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/drag.svg
// module id = vRhf
// module chunks = 45